import { TextField } from "@mui/material";
import { TextFieldProps } from "@mui/material/TextField";
import React from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";

export type NumberTextFieldProps = Omit<
  TextFieldProps,
  "onChange" | "value"
> & {
  onChange?: (v: string | number) => void;
  value?: string | number;
} & Omit<NumericFormatProps<TextFieldProps>, "onChange">;

export const NumberTextField: React.FC<NumberTextFieldProps> = ({
  onChange,
  max,
  min,
  ...props
}: NumberTextFieldProps): JSX.Element => {
  return (
    <NumericFormat
      {...props}
      customInput={TextField}
      onValueChange={
        onChange
          ? (values) => {
              (values.value.startsWith("0") && props.allowLeadingZeros) ||
              !values.floatValue
                ? onChange(values.value)
                : onChange(values.floatValue);
            }
          : undefined
      }
      isAllowed={(values) => {
        const { floatValue = 0 } = values;
        let isAllowedMax = true;
        let isAllowedMin = true;

        if (typeof max === "number") {
          isAllowedMax = floatValue <= +max;
        }

        if (typeof min === "number") {
          isAllowedMin = floatValue >= +min;
        }

        return isAllowedMax && isAllowedMin;
      }}
    />
  );
};
